/* eslint-disable @typescript-eslint/naming-convention */
import { ENVIRONMENT, PlatformEnv } from '@evc/platform';

import type { AppKey, IEnvironment } from '@olympus/ngx-shared';
import { APP_KEYS } from '@olympus/ngx-shared';
import { BuildEnv, DeployEnv, IStaticFlagsEnvironment } from 'shared-modules-angular/feature-flags';
import { getLocation } from 'shared-utils/window';

export function isEvidentConnectHost(): boolean {
  return !getLocation().hostname.includes('ims');
}

export function isWindviewHost(): boolean {
  return getLocation().hostname.includes('wind');
}

export function isOneutviewHost(): boolean {
  return getLocation().hostname.includes('oneutview');
}

export function getAppName(): AppKey {
  if (isOneutviewHost()) {
    return APP_KEYS.ONEUTVIEW;
  }

  return isWindviewHost()
    ? APP_KEYS.WINDVIEW
    : APP_KEYS.AEROVIEW;
}

export function getClientId(): string {
  if (isOneutviewHost()) {
    // TODO: placeholder until the client ID is registered
    return '00000000-0000-0000-0000-000000000000';
  }

  return isWindviewHost() ? '8afb327a-f567-4379-b1b4-08744a5f7727' : '6ae6722b-362e-4848-87bd-277b2e03a8a5';
}

export const baseEnvironment: { [key: string]: any } & PlatformEnv & IEnvironment & IStaticFlagsEnvironment = {
  /**
   * @deprecated use `build` instead
   */
  ENV: ENVIRONMENT.development,
  AUTH_CLIENT_ID: getClientId(),
  USE_CONNECT_PLATFORM: isEvidentConnectHost(),
  APP_NAME: getAppName(),
  PROTECTED_URIS: {
    UNIS_UT: 'https://unis-ut.api.ca.connect.dev-evcnt.com',
  },
  /**
   * @deprecated use `build` instead
   */
  production: false,
  /**
   * @deprecated use `deployment` instead
   */
  local: false,
  /**
   * @deprecated use `deployment` instead
   */
  electron: false,
  licenseType: null,
  cloudConnected: false,
  networkSettings: false,
  performanceSettings: false,
  checkLicenseWeb: false,
  build: BuildEnv.DEV,
  deployment: DeployEnv.WEB,
};
